import * as React from 'react';
import { Modal } from 'react-bootstrap';
import { cancelTempRequest } from '../api';

interface JobAcceptedProps {
  phone?: string;
  job?: {
    id?: number;
    requestId?: number;
  };
  practice?: {
    id?: number;
    name?: string;
  };
}

export default function JobAccepted({
  phone,
  job,
  practice
}: JobAcceptedProps) {
  // Show Popup State
  const [modalOpen, setModalOpen] = React.useState(true);

  // Close Modal
  const closeModal = () => setModalOpen(false);
  // Cancel handler
  const handleCancel = async () => {
    try {
      // Confirm with user before cancelling
      const confirmed = window.confirm('Are you sure you want to cancel this job?');
      if (!confirmed) return;

      if (!job?.requestId && !job?.id) {
        // nothing to cancel
        return;
      }

      const tempRequestId = job.requestId || job.id;
      await cancelTempRequest(tempRequestId);
      // close modal after successful cancel
      setModalOpen(false);
    } catch (err) {
      // swallow errors for UI - tests mock the api
    }
  };

  return (
    <>
      <Modal show={modalOpen} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            Temp Job Accepted
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <h3>YOU ACCEPTED THIS TEMP JOB!</h3>
          <br />
          <h5>NEXT STEP</h5>
          <p>You are now Booked for this Temp Job, please view the info below and call the Practice to confirm the job details at <strong>{phone}</strong>.</p>
          <h5>VERY IMPORTANT</h5>
          <p>If you are unable to keep your commitment to this job, please call the Practice to inform them ASAP.
            Note that cancelling on jobs after you have accepted can potentially have a negative impact on your professional profile rating.
          </p>

          <div className="d-flex justify-content-center">
            <button className="btn btn-secondary mr-2" onClick={handleCancel}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={closeModal}>
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
